import { PersonNotifyLogStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { IGenerateOptionsProps } from './__types'

function generateOptions({ max, suffix = '', startsZeroed }: IGenerateOptionsProps) {
  return new Array(max).fill(0).map((_, index) => {
    const number = startsZeroed ? index : index + 1
    return {
      label: `${number}${suffix}`,
      value: number,
    }
  })
}

export const countOptions = generateOptions({ max: 10, suffix: ' +' })
export const petsOptions = generateOptions({ max: 5, startsZeroed: true })

export const quoteStatusOptions = [
  { title: 'All', value: '' },
  { title: 'Delivered', value: PersonNotifyLogStatus.delivered },
  {
    title: 'Opened',
    value: PersonNotifyLogStatus.opened,
  },
  {
    title: 'Clicked',
    value: PersonNotifyLogStatus.linkClicked,
  },
  {
    title: 'Booked',
    value: 'booked',
  },
]

export const quotesExportableFields = [
  { label: 'Id', path: 'id' },
  { label: 'Name', path: 'name' },
  { label: 'Address', path: 'address' },
  { label: 'City', path: 'city' },
  { label: 'Zip Code', path: 'zipCode' },
  { label: 'Market', path: 'region' },
  { label: 'Bedrooms', path: 'bedroomsCount' },
  { label: 'Bathrooms', path: 'bathroomsCount' },
  { label: 'Half Bathrooms', path: 'halfBathroomsCount' },
  { label: 'Max Occupancy', path: 'maxOccupancy' },
  { label: 'Pet Policy', path: 'petPolicy' },
]
